import { Address, encodeFunctionData, isAddress, parseAbi } from "viem";

export const POLYGON_NAME_SERVICE_ABI = parseAbi([
  "function tld() view returns (string)",
  "function price(string label) view returns (uint256)",
  "function getAddress(string label) view returns (address)",
  "function getRecord(string label) view returns (string)",
  "function tokenIdFor(string label) view returns (uint256)",
  "function registerWithRecord(string label, string record) payable returns (uint256 tokenId)",
  "function setRecord(string label, string record)",
]);

const configuredAddress = import.meta.env.VITE_POLYGON_NAME_SERVICE_ADDRESS as string | undefined;
export const POLYGON_NAME_SERVICE_ADDRESS = configuredAddress && isAddress(configuredAddress)
  ? configuredAddress as Address
  : undefined;

export const POLYGON_NAME_TLD = ".kairos";
export const MAX_DOMAIN_RECORD_BYTES = 2048;
export const normalizeDomainLabel = (value: string) => value.trim().toLowerCase().replace(/\.kairos$/i, "");
export const validateDomainLabel = (value: string) => {
  const label = normalizeDomainLabel(value);
  if (!/^[a-z0-9](?:[a-z0-9-]{1,61}[a-z0-9])$/.test(label)) {
    throw new Error("Use 3-63 lowercase letters, numbers, or interior hyphens.");
  }
  return label;
};

export const validateDomainRecord = (value: string) => {
  const record = value.trim();
  if (new TextEncoder().encode(record).length > MAX_DOMAIN_RECORD_BYTES) {
    throw new Error(`Domain records cannot exceed ${MAX_DOMAIN_RECORD_BYTES} UTF-8 bytes.`);
  }
  return record;
};

export const encodeDomainRegistration = (label: string, record: string) => encodeFunctionData({
  abi: POLYGON_NAME_SERVICE_ABI,
  functionName: "registerWithRecord",
  args: [validateDomainLabel(label), validateDomainRecord(record)],
});
